module.exports = __webpack_public_path__ + "img/about_pic.28829c54.png";